export interface IAction {
    type: ActionType;
    requestType?: RequestType;
    data?: IActionData;
}

export enum ActionType {
    // Mount events
    OnHotTodayMount,
    OnCodeBitsListMount,
    OnCodeBitsListPageMountHandler,

    // Click events
    OnProfileButtonClick,
    OnCodeBitClick,
    OnTopicClick,
    OnSearchClick,
    OnNewCodeClick,
    OnPaginationClick,
    OnEmptyCodeBitsCTAClick,

    // Input events
    OnPostTagInputChange,

    // Business actions
    GetCodeBitsList,
    GetHotTodayTopics,
    OrderFilterChange,
    LanguageFilterChange,
    GetLanguagesCatalog,

    // Tracking
    Track,
}

export enum RequestType {
    Parallel,
    Cancelable,
    Sequential,
}

export interface IActionData {
    trackData?: ITrackActionData;
    sortType?: number;
    codeBitsListSearchText?: string;
    orderFilter?: string;
    languageFilter?: string;
    currentPageNumber?: number;
    userId?: number;
    alias?: string;
    pageNumber?: number;
    pageAlias?: string;
    id?: number;
    codeId?: string;
    searchedInputValue?: string;
    ctaType?: MainCTAType;
    ctaURL?: string;
    text?: string;
    linkClickSource?: LinkClickSource;
    clickedPageNumber?: number;
    paginationCtaType?: PaginationCTAType;
    selectedOrderFilter?: string;
    selectedLanguageFilter?: string;
    pathname?: string;
}

export enum TrackActionName {
    OnCodeBitsPageMount = 'onCodeBitsPageMount',
    OnProjectClick = 'onProjectClick',
    OnSearchClick = 'onSearchClick',
    OnCTAClick = 'onCTAClick',
    OnPaginationClick = 'onPaginationClick',
    OrderFilterChange = 'orderFilterChange',
    OnCourseClick = 'onCourseClick',
}

export interface ITrackActionData {
    actionName: TrackActionName;
    questionId?: string;
    pageAlias?: string;
    codeId?: string;
    source?: string;
    postId?: string;
    tagAlias?: string;
    ctaType?: MainCTAType;
    paginationCtaType?: PaginationCTAType;
    pageNumber?: number;
    clickPageNumber?: number;
    searchText?: string;
    sectionName?: string;
    languageName?: string;
    materialId?: string;
    experienceAlias?: string;
    linkClickSource?: LinkClickSource;
    hyperText?: string;
    hyperLink?: string;
}

export enum PaginationCTAType {
    Next = 'NEXT',
    Previous = 'PREVIOUS',
    PageNumber = 'PAGE_NUMBER',
}

export enum MainCTAType {
    NewCode = 'NEW CODE',
    CreateNewCode = 'CREATE NEW CODE',
    SignIn = 'LOGIN',
    SignUp = 'REGISTER',
    TryAgain = 'TRY_AGAIN',
    Course = 'COURSE',
    Delete = 'DELETE',
    Save = 'SAVE',
}

export interface ISelectedTags {
    label: string;
    value: string;
}

export enum LinkClickSource {
    TITLE = 'TITLE',
    DESCRIPTION = 'DESCRIPTION',
    ANSWER = 'ANSWER',
}
